import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable, ReplaySubject, forkJoin } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../../demo.service';


// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SearchSettingsModel, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, DataUtil  } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
// import { HotToastService } from '@ngneat/hot-toast';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MysqlService } from './../../../services/mysql.service';
import { HotToastService } from '@ngneat/hot-toast';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

declare const saveDocument: any;
declare const loadDocument: any;
declare const TXTextControl: any;

declare const loadData2: any;
declare const loadDocument_TEMPLATE: any;
declare const loadDocument_DocumentCreated: any;

// ... end txc // must be string
interface MergedDocument {
  document: any;
  DocumentName: string;
  password?: string;
  model?: any;
}


interface DocumentViewModel
{
    DocumentName: string;
    BinaryDocumet: String //btao
}

@Component({
  selector: 'app-jobs-file-grid',
  templateUrl: './jobs-file-grid.component.html',
  styleUrls: ['./jobs-file-grid.component.css']
})
export class JobsFileGridComponent implements OnInit, OnChanges {


  // passed Values.
   // setup as observable?
   @Input() item_id?; // impliments on changes. // Base set to Job_ID
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = null;
   @Input() item_brand_id? = null;
   @Input() item_subject_id? = null;
   @Input() item_subject_number? = '';
   
   @Input() show_buttons? = 'no'; // yes | no
   @Input() item_title? = '';
   @Input() widget_size? = 'full'; // side | abstract | full


   @Input() file_number?: any; // subject file number
   @Input() subject_number?: any; // subject file number
   @Input() brand_type_id?: any; // subject file number
   @Input() reference_number?: any;

   // if we have a log type id -- we can set what log to run on file Upload...???/// passed from component to component
   @Input() log_type_id?: any;

  //  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

   // FIles Grid now accepts app_route_files - master system files and notes system
   @Input() app_route_id?: any; // subject file number


   @Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();
   @Output('onAdd') onAdd: EventEmitter<any> = new EventEmitter();
   @Input() is_attach_method?;

   @Input() attach_file_array_name?: any;

  // @ViewChild('grid')
  @ViewChild('grid') public grid: GridComponent;
  // public grid: GridComponent;
  public searchOptions: SearchSettingsModel;
 
  public pageSettings: Object;
  public pageOptions = { pageSize: 20 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: any;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  dateFormat: string;
 
  files: any;
  @Input() job_id: any;
  model: {};
  modalRef: BsModalRef;
  systemFile_themed_data: any;
  doc_subject_com_type: any;
  selected_template_name: any;
  file_name_header_removed: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  files_table: any;
  del_files: Object;
  files_data: any;
  agent_array: any;
  show_agents: any;
  created_file: {
    // log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    // log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    // created_by: this.gfunc.sessionUserId,
    // created_date: this.gfunc.today,
    // subject_id: this.subject_id,
    // job_id: this.job_id,
    // job_reference_number: this.job_id,
    // file_number: this.file_number,
    // reference_number: this.reference_number,
    // subject_number: this.subject_number,
    // // subject_number: model.file_subject_number,
    // log_type_id: 1, // see datatable system_log_types
    // created_level: this.gfunc.sessionUserLevel,
    // brand_type_id: brand_type_id,
    // subject_com_type_id: null,
    // subject_template_doc_id: null,
    // log_name: log_name + ' - ' + this.created_file_name,
    // file_id: inserted_file_id,
    // last_insert_id: this.returned_created_file_id,
    // file_name: this.created_file_name
    file_name: any; job_file: number; subject_file: number; file_id: any; file_server_location: any; file_ext: any; file_brand_id: any; file_access_level: any; assigned_to_agents: any; brand_type_id: any;
  }[];
  file_data: any[];
  file_password_data: any;
  file_password: any;
  _baseUrl: string;
  templateDocxName: any;
  file_subject_number: any;
  base64Output: string;
  set_PDF_blob: Blob;
  returned_file_password: any;
  resultMessage: any;
  returned_AdobeAPI_go_encrypt: any;
  adobeAPI_upload: any;
  adobeAPI_download: any;
  AdobeAPI_succes_close_data: any;
  

  

  
  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute, private router: Router,
    public datepipe: DatePipe,  public gfunc: GlobalFunctionsService,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    private _mysqlService: MysqlService,
    private toastr: HotToastService,
  ) {

    this._baseUrl = gfunc.azure_webRootPath; // API Root

if (this.is_attach_method == null){
this.is_attach_method = 0;
}

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


        // Setup Grid
        this.toolbarOptions = ['ExcelExport', 'Search', {
          text: '-',
          tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Clic2k'
        }
        ]; 

        // this.toolbarOptions = ['Search'];
        // this.toolbarOptions = ['ExcelExport', 'Search'];

        // this.toolbar = [
        // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];
      //  this.initialPage = { pageSize: 100 };
        this.filterOptions = {
          type: 'Menu'
        };
        this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
        this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
        this.dateFormat = 'dd/MM/yyyy hh:mm a';
        this.filter = { params: { format: this.dateFormat } };

   }


   // check for changes. to load data.
   ngOnChanges(changes) {
    if (changes.item_id) {

            //     setTimeout(() => {  
            //       console.log("A Simple Pause! OnChanges 1 jobs file Grid"); 
            //   console.log("Now Ready to load...");
            // }, 1000);
      // deal with asynchronous Observable result
     this.job_id = changes.item_id.currentValue;
     // this.getJob(this.job_id);
     // this.getFiles();

console.log("Onchanges: Job ID: " + this.job_id);

     // put model.
this.model = {
  file_job_id: this.job_id,
//  file_brand_id: this.item_brand_id,  // changed now to see if can see files on subejct card - agent view.
  brand_type_id: this.item_brand_type_id, // show files only related to login brand. client | owner | agent
  // brand_type_id: 0, // show files only related to login brand. client | owner | agent
  file_number: this.file_number,
  // subject_number: this.item_subject_number // was commented
};


// see if this works to put agent names on the grid for admins and
          // if (this.gfunc.sessionBrandTypeId == 1){
          // this.model = []; // reset and set.
          //        // put model.
          // this.model = {
          //   file_job_id: this.job_id,
          // //  file_brand_id: this.item_brand_id,  // changed now to see if can see files on subejct card - agent view.
          //         //  brand_type_id: this.item_brand_type_id, // show files only related to login brand. client | owner | agent
          //          brand_type_id: 0, // show files only related to login brand. client | owner | agent
          //   file_number: this.file_number,
          //   // subject_number: this.item_subject_number // was commented
          // };


          // }


// if (this.item_brand_type_id == 3){
//   this.model = {
//     file_job_id: this.job_id,
//   //  file_brand_id: this.item_brand_id,  // changed now to see if can see files on subejct card - agent view.
//     brand_type_id: this.item_brand_type_id, // show files only related to login brand. client | owner | agent
//     // brand_type_id: 0, // show files only related to login brand. client | owner | agent
//     file_number: this.file_number,
//     // subject_number: this.item_subject_number // was commented
//   };
// }


// if(this.item_subject_number != null) {
//   // added the subject number.
//   this.model = {
//     file_job_id: this.job_id,
//    // file_brand_id: this.item_brand_id, 
//     brand_type_id: this.item_brand_type_id, // show files only related to login brand. client | owner | agent
//     file_number: this.file_number,
//     subject_number: this.item_subject_number
//   };
// }

     this.getJobFilesGrid(this.model); // Put Event instead of Get?? Do I get a response of data?




     



    }
    if (changes.item_data) {
      // deal with asynchronous Observable result
     this.job_id = changes.item_id.currentValue;
     // this.getJob(this.job_id);
    //  this.getFiles();


    }

    // if (changes.attach_file_array_name) {
    // this.attach_file_array_name = changes.attach_file_array_name.currentValue;
    // }

  }


   ngOnInit() {
   // this.getFiles();
   // Moved to observables.
        // put model.
        this.job_id = this.item_id;
        

        
  //  this.getJobFilesGrid(this.model);
  }


  private getFiles() {
    this._demoService.fetchSystemFiles().subscribe(
      (res) => (this.files = res),
      (err) => console.error(err.status)
    );
  } /* */


  private getJobFilesGrid(model) {
    this.show_agents = [];
    this.files = [];


    console.log('Load This Model: ', JSON.stringify(model));
this.model = model;


    this._demoService.getJobFilesGrid(model).subscribe(
      res => {
        // this.files = res;
        // this.files_table = this.files.slice(0, 10);
        this.files_data = res;
        // this.notes = data;
    
    
        this.files_table = this.files_data.slice(0, 10);


// -- need a fix to show the agent name without errors. Nov 2022 - works for everyone expect admin!!!!!
  if (this.gfunc.sessionUserLevel != 1) {
        // if (this.gfunc.sessionUserLevel == 5) {

// array for agents display test may not be correct if other agents?
let newArrA = res;
//  let  count_of_items = Object.keys(newArrA).length;
let  count_of_items = Object.keys(newArrA).length;
   // need to do a loop of subject_billing items (.length)
   for(let i=0;i < count_of_items; i++) {
   let res22 = newArrA[i];

   // just grabs the first agent. // as pass was throwing errors. // end of json.
//  let parsed_array = [];
// if (!res22.assigned_to_agents){
//   this.agent_array = JSON.parse(res22.assigned_to_agents);
// }else{
//   this.agent_array = [];
// }

   
this.agent_array = JSON.parse(res22.assigned_to_agents);

//    this.show_agents.push({
//      recipient_name: res22.recipient_name + '',
//      recipient_email_address: newArrA[i].recipient_email_address,
//      recipient_brand_id: res22.recipient_brand_id,
//      recipient_subject_id: res22.subject_id,
//      recipient_brand_type_id: res22.brand_type_id,
//      recipient_user_id: null,
//      recipient_user_level_id: null,
//      recipient_type_name: res22.recipient_type_name,
//    });
   } // end for loop
//  this.show_agents = this.show_agents; // ?? this may be causing errors.
// console.log(JSON.stringify(this.agent_array));

this.show_agents = this.agent_array; // ?? this may be causing errors.

   }




// new sysetm to filter only notes for agents views.
if (this.gfunc.sessionUserLevel == 5) {
console.log('Agent Login Detected: ', this.gfunc.sessionBrandName);
// need to filter the results if exists in the assinged_to_agents array, create a new note array
let array = [];
let newArr = Object(res).filter((sbi)=>(sbi.assigned_to_agents !== '[]')); // User this if filter is needed.
// let newArr = data;
let  count_of_items = Object.keys(newArr).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0;i < count_of_items; i++) {
    let res2 = newArr[i];
    // ned to see if exists in array if so push to notes array.

    
    // array = res.assigned_to_agents;
array = JSON.parse(res2.assigned_to_agents);
// console.log('array: ', array);
// let ata_array = array;

    let ata_array = array.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array
if (ata_array.length === 1) {
  this.files.push({
  ...newArr[i]
  });
} // end if array.lenght

} // end for loop agent.... 


// commented out as this was loading all the files...????? 
                  // this.files = this.files;
                  // // this.notes = data; // activated so clients can see notes
                  // this.files_table = this.files.slice(0, 10);
// console.log('Filtered Agent File Access: ', JSON.stringify(this.files));
 

// This function is very important and now pauses then load the document correctly.
            // setTimeout(() => {  
            //   console.log("A Simple Pause!"); 
            //   console.log("Now Ready to load...");

              
            //   this.grid.refresh();
            //   // run the function instead to reload everything properly.
            //   this.refreshGrid(); // refresh the databutton

            // }, 1000);

this.grid.refresh();
// this.allRecipients = this.allRecipients; // ?? this may be causing errors.







// filters the notes and checks if the current agent brand id exists in the array
// tslint:disable-next-line:max-line-length
          // this.notes = this.notes_data.filter( (n: any) => (
          //   n.assigned_to_agents[0].recipient_brand_id === this.gfunc.sessionBrandId
          
          //   // n.note_id >= '200'
          //   // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
          //   ));

          // console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
console.log('Current Brand ID: ', this.gfunc.sessionBrandId);

      // let newArr = Object(data).filter((sbi)=>(
      //   sbi.assigned_to_agents != '[]'
      //   && sbi.assigned_to_agents.recipient_brand_id === this.gfunc.sessionBrandId
      //   )); // User this if filter is needed.
      // // let newArr = data;

      // let  count_of_items = Object.keys(newArr).length;
      //   // need to do a loop of subject_billing items (.length)
      //   for(let i=0;i < count_of_items; i++) {
      //   let res = newArr[i];
      //   this.notes.push({
      // ...newArr[i],
      //   });
      //   } // end for loop
      // // this.notes = this.notes; // ?? this may be causing errors.
      //   console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
      // this.grid.refresh();



      // :: Filter object inside an object - using findIndex.
      // @https://stackoverflow.com/questions/43405841/filtering-json-object-on-an-object-inside-an-object
      // group3Items = items.filter(item => item.groups.includes(group => group.id==3))

      // tslint:disable-next-line:max-line-length
      // let group3Items =  this.notes_data.filter(item => item.assigned_to_agents[0].findIndex(group => group.recipient_brand_id==this.gfunc.sessionBrandId) > -1);

      //       let group3Items = this.notes_data.filter(
      //         item => item.assigned_to_agents !== '[]'
      //         && item.assigned_to_agents.includes(assigned_to_agents => assigned_to_agents.recipient_brand_id === '99')
      //         );
      // this.notes = group3Items;
      //       console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
      // this.grid.refresh();



      // new function that does the magic
      // this.transform(JSON.stringify(this.notes), this.gfunc.sessionBrandId);
}else {
  // this.files = res;
  // this.files_table = this.files.slice(0, 10);
} // end if agent logged in.





// fix for files notes needing a filter. (files have a file_brand_id brand_type)
if (this.gfunc.sessionUserLevel == 9) {
  this.files_data = []; // empty the array first
  let newArr = Object(res).filter((sbi)=>(
    sbi.file_brand_id === this.gfunc.sessionBrandId
    || sbi.brand_type_id === this.gfunc.sessionBrandTypeId
    )); // User this if filter is needed.
  // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
//  this.notes = DataUtil.parse.parseJson(newArr);
 this.files = newArr;
// this.notes = data; // activated so clients can see notes
this.files_table = this.files.slice(0, 10);
this.grid.refresh();

  } // end if client logged in.



if (this.gfunc.sessionUserLevel == 9 ) {
  this.files_data = []; // empty the array first
  let newArr = Object(res).filter((sbi)=>(
    sbi.file_brand_id === this.gfunc.sessionBrandId
    || sbi.brand_type_id === this.gfunc.sessionBrandTypeId
    )); // User this if filter is needed.
  // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
//  this.notes = DataUtil.parse.parseJson(newArr);
 this.files = newArr;
// this.notes = data; // activated so clients can see notes
this.files_table = this.files.slice(0, 10);
this.grid.refresh();

  } // end if client logged in.

  // client agent permisions - august 2025
      //    if (this.gfunc.sessionUserLevel == 9 && this.gfunc.sessionBrand_is_client_show_agent_level == '1') {
      //       this.files_data = []; // empty the array first
      //   let newArr = Object(res).filter((sbi)=>(
      //     // sbi.file_brand_id === this.gfunc.sessionBrandId 
      //     sbi.brand_type_id === this.gfunc.sessionBrandTypeId || sbi.brand_type_id == 3
      //     )); // User this if filter is needed.
      //   // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      // //  this.notes = DataUtil.parse.parseJson(newArr);
      //  this.files = newArr;
      // // this.notes = data; // activated so clients can see notes
      // this.files_table = this.files.slice(0, 10);
      // this.grid.refresh();

      //    }

//

        if (this.gfunc.sessionUserLevel == 9 && this.gfunc.sessionBrand_is_client_show_agent_level == '1') {
            this.files_data = []; // empty the array first
        let newArr = Object(res).filter((sbi)=>(
          // sbi.file_brand_id === this.gfunc.sessionBrandId 
         sbi.created_by_level !== "5" && sbi.brand_type_name !== 'TSA Staff' 
          )); // User this if filter is needed.
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      //  this.notes = DataUtil.parse.parseJson(newArr);
       this.files = newArr;
      // this.notes = data; // activated so clients can see notes
      this.files_table = this.files.slice(0, 10);
      this.grid.refresh();

         }

/*

//new way show all and remove by agent created level. -- THIS WORKS BUT NEED TO UPDATE ALL API TO RETURN THIS>...
// sbi.brand_id === this.gfunc.sessionBrandId && s
if (this.gfunc.sessionUserLevel == 9 && this.gfunc.sessionBrand_is_client_show_agent_level == '1') {
  this.notes = Object(this.getSubjectNotesProgressionTable_data).filter((sbi) => {
    // const user = this.usersList.find(u => u.id === sbi.created_by_id);
    return (
      sbi.created_by_level !== "5" && sbi.brand_type_id !== 'TSA Staff' 
    );
  });
}


*/








// may need this one to run last
// this.grid.refresh();
if (this.gfunc.sessionUserLevel <= 4) {
  this.files = res;
  this.files_table = this.files.slice(0, 10);
 this.grid.refresh();
}

      },
      (err) => console.error(err.status)
    );
  } /* */




  
// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.files }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}

subjectEditLink(subject_id) { 
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
this.gfunc.globalJobSubjectViewSkipRoute(subject_id);
}


viewSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
  this.gfunc.globalViewSystemFile(file_id);
}




// New delete any job or subject file fuction - Beta Testing
deleteJobFileAny(filename, job_id, file_make, file_server_location) {
  // if (confirm('Are you sure you want to delete this file? ')) {
    this._mysqlService.deleteJobFileAny(filename, job_id, file_make, file_server_location).subscribe(
       data => {
         // this.getTraceNotes(this.trace_id);
        this.refreshGrid();
         return true;
       },
       error => {
         console.error('Error deleting Job File!');
        //  return Observable.throw(error);
       }
    );
// }
}

deleteSystemFileAssigned(model){
  this._demoService.deleteSystemFileAssigned(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('Assigned Files deleted', model.file_id + ' ' + model.full_file_name),
      // this.files_table = this.files.slice(0, 10)
      this.toastr.success( "Assigned/Shared File Records Removed")
      ),
    (err) => console.error(err.status)
  );
}

deleteSystemFile(model){
  // if (confirm('Are you sure you want to delete this file assign/share record, master file will remain? ')) {
  this._demoService.deleteSystemFile(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('File deleted', model.file_id + ' ' + model.full_file_name),
      // this.files_table = this.files.slice(0, 10)
      this.toastr.success( "Assigned/Shared File Record Removed"),
      // this.grid.refresh() 
      this.refreshGrid()
      ),
    (err) => console.error(err.status)
  );
    // }
}



// this deletes the lot!
deleteSystemJobFile(model) {
  console.log('FileID: ', model.file_id);
  if (confirm('Are you sure you want to delete this file, data and associations from the system? ')) {
  // change into a subscruption and delete the file action.
// 1: delete from database + Log action
this.deleteSystemFileAssigned(model);
// 2: Delete file from server
this.deleteSystemFile(model);
// logg the process
this.gfunc.insertLog_DeleteSystemFile(model);
// 3: Delete the pysical file from the server file
if (model.file_server_location !== '') {
this.deleteJobFileAny(model.full_file_name, model.file_job_id, model.file_make, model.file_server_location);
console.log('physicalFILEdelete active: ');
// find out what type of tile it is and then detete the file.
}
console.log('Success: Data + File deleted', model.file_id + ' ' + model.full_file_name);

// Added for new PDF REmoval
if(model.file_ext == 'pdf'){
  this.sendUploadedDocumentCreatedViaFTP_Delete(model, model.full_file_name, model.file_subject_number, model.file_job_id)
}

this.refreshGrid();
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
 // this.gfunc.globalViewSystemFile(file_id);

 // REfreshes page to try fixc upload error after deleting a file.
 if (this.gfunc.current_base_route == '/client/jobs/create-job-wizard-step-3/'){
  this.gfunc.globalJobEditStep3SkipRoute(this.job_id);
 }

  } // end confirm
}

editSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
  this.gfunc.globalEditSystemFile(file_id);
}

editDocFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
  this.gfunc.globalEditDocFile(file_id);
}


editDocxSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  this.gfunc.globalEditDocxSystemFile(file_id);
}

editDocxSystemFileHTML(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit-html/' + file_id + '']);
}



viewDocxSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  this.gfunc.globalViewDocxSystemFile(file_id);
}

viewDocxSystemFileHTML(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view-html/' + file_id + '']);
}


refreshGrid(){ // refresh the databutton
 // this.getFiles();



 console.log('Refresh This Model: ', JSON.stringify(this.model));
 this.getJobFilesGrid(this.model);

 
  this.grid.refresh();
};


assignJobFileToSubject(){
  console.log('Assinged Clicked');
}


// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.refreshGrid();
  this.modalRef.hide();
 
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div

// :: Reloads the email list


};






addHeadersFooters2(model, file_name, subject_com_type_id, subject_number) {
// let model_json = JSON.stringify(data);
  // model.is_theme = true;
  if (confirm('Are you sure you want to Save with Theme, ready to send to client. You cannot edit the file online once you theme the document? ')) {
  // model.attached_file_name = this.created_file_name;

//need to lookup template name. from subject_com_type_id

this._demoService.getSubjectComType(subject_com_type_id).subscribe(
  (res) => {
    this.doc_subject_com_type = res;
    let rsdata = res[0];
    //  this.selected_template_name = this.doc_subject_com_type.document_base_theme_docx;
    this.selected_template_name = rsdata.document_base_theme_docx;
    console.log('Theme File: ' + rsdata.document_base_theme_docx);


              this._mysqlService.addHeadersFooters2(model, file_name, this.selected_template_name, subject_number).subscribe(
                data => {  this.systemFile_themed_data = data;
                // this.toastr.success('Added Headers + Footers.');
                const res = data;
                console.log('Headers Added to: ' + res[0].text());

                // this totally worked
                // this.LoadServerFileHTMLViaAPI(templateDocxName);
                this.refreshGrid();

            },
                error => {
                  // this.toastr.error('Error Loading!');
                  console.error(error);
                }
            );
                  // ednd myzsql function
      },
      (err) => console.log(err.error)
    );
        


  }// end confirm
}






addHeadersFooters(model, file_name, subject_com_type_id, subject_number) {
  // let model_json = JSON.stringify(data);
    // model.is_theme = true;
    if (confirm('Are you sure you want to Save with Theme, ready to send to client. You cannot edit the file online once you theme the document? ')) {
    // model.attached_file_name = this.created_file_name;
  
  //need to lookup template name. from subject_com_type_id
  
  this._demoService.getSubjectComType(subject_com_type_id).subscribe(
    (res) => {
      this.doc_subject_com_type = res;
      let rsdata = res[0];
      //  this.selected_template_name = this.doc_subject_com_type.document_base_theme_docx;
      this.selected_template_name = rsdata.document_base_theme_docx;
      console.log('Theme File: ' + rsdata.document_base_theme_docx);
  
  
                this._mysqlService.addHeadersFooters(model, file_name, this.selected_template_name, subject_number).subscribe(
                  data => {  this.systemFile_themed_data = data;
                  // this.toastr.success('Added Headers + Footers.');
                  const res = data;
                  console.log('Headers Added to: ' + res[0].text());
  
                  // this totally worked
                  // this.LoadServerFileHTMLViaAPI(templateDocxName);
                  this.refreshGrid();
  
              },
                  error => {
                    // this.toastr.error('Error Loading!');
                    console.error(error);
                  }
              );
                    // ednd myzsql function
        },
        (err) => console.log(err.error)
      );
          
  
  
    }// end confirm
  }




  removeHeadersFooters(model, file_name, template_name, subject_number) {
    if (confirm('Remove Theme for Editing?, once removed you can edit the document again online. You can then re-apply after you edits.')) {
    // model.attached_file_name = this.created_file_name;
    this._mysqlService.removeHeadersFooters(model, file_name, template_name, subject_number).subscribe(
      data => {  this.file_name_header_removed = data;
      // this.toastr.success('Removed Headers + Footers.');
      const res = data;
      // this totally worked
      this.refreshGrid();
},
      error => {
        // this.toastr.error('Error Loading!');
        console.error(error);
      }
  );
    } // end confirm
  }



  clearSearchGrid() {
    this.grid.searchSettings.key = '';
}

  searchGrid(name) {
    this.searchOptions = {  };
    this.grid.searchSettings.key = '';
    // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
    const searchText: string = name;
    this.grid.search(searchText);
  
}

searchGridCol(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['file_make'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}



// NOT WORKING
searchGridMasters(name) {
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { 
    fields: ['assigned_to_subjects'], operator: 'equal', key: name
   
  };
  // now refresh the grid
  this.grid.refresh();

}




// Need to know I have all newly created file details to automatically add to the array

 // Function setup to lookup file details and add to arrays of the attempt page automatically.
 onAttachttemptFile(data, attach_file_array_name){
        // need to lookup the file
        // htne fill the sysetm 
    // this.toastr.info('attempting to auto attach to attempt report for you ...');

        // set the variable and addd to the model to auto add the attmpt files to the correct array
        ///this.file_data[0].attach_file_array_name = this.attach_file_array_name;
        ///// re model quicky to add the record of the array name to the data model
        this.file_data = [{
        ...data,
        attach_file_array_name: attach_file_array_name
        }]

        console.log('Created File: ', JSON.stringify(this.file_data) );


        // this.file_data = DataUtil.parse.parseJson(this.file_data); // needs to be in grid format for orginal add onAdd Grid Button.
        this.onAdd.emit(this.file_data);

}




getFilePasswordKeyHash(model) {
  this.file_password = ''; // reset them all so just show current.
  this._demoService.getFilePasswordKeyHash(model).subscribe(
    data => { 
      this.file_password_data = data;
      this.file_password = this.file_password_data.file_password
    
    },
    err => console.error(err),
    () => console.log('done loading company')
  );
}



encryptSystemFile(model) {
  // generate more data first
  if (confirm('Are you sure you want to encrypt and lock file with a password? ')) {
  this._mysqlService.encryptSystemFile(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Document Encryption Success.');
      const res = data;
    this.refreshGrid();
    },
    (error) => {
     return error.error;
    },
    //  () => console.log('')
  );
}
}


encryptSystemFileJustData(model) {
  // generate more data first
  // if (confirm('Are you sure you want to encrypt and lock file with a password? ')) {
  this._mysqlService.encryptSystemFileJustData(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Document Encryption Success.');
      const res = data;
    this.refreshGrid();
    },
    (error) => {
     return error.error;
    },
    //  () => console.log('')
  );
// }
}



encryptSystemFileGetPassword(model) {
  // generate more data first
  // if (confirm('Are you sure you want to encrypt and lock file with a password? ')) {
  this._mysqlService.encryptSystemFileGetPassword(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.info('Setting Datas... Please Wait...');
      const res = data;

      console.log('Pswd Rtrn: ' + JSON.stringify(data))

      this.returned_file_password = data[0];
      console.log('actual: ' + this.returned_file_password);

    // this.refreshGrid();
    },
    (error) => {
     return error.error;
    },
    //  () => console.log('')
  );
// }
}


// How to covert pdf file to base64
// ::@https://stackoverflow.com/questions/36280818/how-to-convert-file-to-base64-in-javascript

 // Function runs
 async onClickMergeDocumentEncrypt(filename, subject_number, data, file_url) {
  // : 'https://tsa.backvault.com.au/APP_PHP/uploads/assets/jobs',

  
  // Location if uploaded file.
this.convertToBase64_viaURL( this.gfunc.baseUploadURL_JobAssets + '/' + data.file_job_id + '/' + data.file_name);

  // const toBase64 = file_url => new Promise((resolve, reject) => {
  //   const reader = new FileReader();
  //   reader.readAsDataURL(file_url);
  //   reader.onload = () => resolve(reader.result);
  //   reader.onerror = reject;
  // });
  

  // get the saved document from TXTextControl
  // const postDocument: MergedDocument = {
  //   document: await saveDocument(),
  // };

  // const postDocument: MergedDocument = {
  //   document: await toBase64(file_url)
  // };

  // console.log('BLOB: ' + this.set_PDF_blob);

  //   const postDocument: MergedDocument = {
  //   document: this.set_PDF_blob
  // };


  // const postDocument: MergedDocument = {
  //   document: await  this.return_convertToBase64_viaURL(this.gfunc.baseUploadURL_JobAssets + '/' + data.file_job_id + '/' + data.file_name)
  // };




  this.templateDocxName = data.full_file_name;
  this.file_subject_number = subject_number;


             // Run the Single push invcoice Route and 
             setTimeout(() => {  
              console.log("A Simple Pause!");
  
 

              const postDocument: MergedDocument = {
                document: this.set_PDF_blob,
                DocumentName: data.full_file_name,
                password: 'NEED TO SET HERE' // also remember if type of user... so set in a function first.
              };

     // Test if this runs to function and then  
  //   loadDocument(result.document);
  // this.sendWordTemplateViaFTP(data, filename); // moves file over ready for merge in PHP
  //  this.toastr.success('Succesfully Encrypted The new created document!', {icon: '👏🌞',})

  console.log("File in Base64: in time ", this.set_PDF_blob);

  // post the document to endpoint 'MergeDocument' // Saves the file as the same name. // see if works. may not was the file may be open in the stream
            this.http.post<MergedDocument>(this._baseUrl + 'textcontrol/mergedocumentencrypt' + '?documentName='+ data.full_file_name, postDocument).subscribe(result => {
              // this.http.post<MergedDocument>('http://20.70.181.64:80/' + 'textcontrol/mergedocument' + '?DocumentName=' + this.templateDocxName, postDocument).subscribe(result => {
            

              // this.http.post<MergedDocument>(this._baseUrl + 'textcontrol/mergedocument', postDocument).subscribe(result => {
              // load the results into TXTextControl
              

              // Lets conver the Blob and save as PDF through php send and acreate API and function to do this.


            }, error => console.error(error));




            

          }, 6000);





          setTimeout(() => {  
             // get the file automatically
             this.getUploadedDocumentCreatedViaFTP(data, data.full_file_name, data.file_subject_number, data.file_job_id);
            this.encryptSystemFileJustData(data);
            }, 10000);

}



   // Get Invoice Items - Normal get
   encryptPDF_FTP_Backvault(model){
    this._demoService.encryptPDF_FTP_Backvault(model).subscribe(
      (data) => {
        // this.invoiceItemsList = data;
        let res = data[0];
        // this.invoice_item_model = this.invoiceItemsList;
        // this.setMyobInvoiceModelStep2(model); // ru
        // this.updateMyobInvoiceModelStep2(model);
        // this.doCalculations();
        this.toastr.info("AdobePDF API Doing it's work...")
      },
      (err) => console.error(err),
     () => console.log('PDF ENCTYPTED.')
    )};

    
    encryptPDF_FTP_AdobeAPI(model){
      this._demoService.encryptPDF_FTP_AdobeAPI(model).subscribe(
        (data) => {
          // this.invoiceItemsList = data;
          let res = data[0];
          // this.invoice_item_model = this.invoiceItemsList;
          // this.setMyobInvoiceModelStep2(model); // ru
          // this.updateMyobInvoiceModelStep2(model);
          // this.doCalculations();
          this.toastr.success("AdobePDF Encyption Done.")
        },
        (err) => console.error(err),
       () => console.log('PDF ENCTYPTED.')
      )};
  





 onClickMergeDocumentEncrypt_adobeAPI_FTP_BackVault(filename, subject_number, data, file_url) {
  // First sentIT to tsaVM / created Files - works.
  // Comment out and put file manuall for local testing. --
  this.encryptSystemFileGetPassword(data); // load the passwords.

  // works commented out for testing as file lready uploaded.
  this.sendDocumentUploadedViaFTP_AdobeAPI_Backvault(data, filename, subject_number, data.file_job_id); // new adobe api send via fftp to resources folder.

    this.templateDocxName = data.full_file_name;
    this.file_subject_number = subject_number;

    // Now create a new Demo services Route to get acess to adobeapi.tsa_backvault.com.au -- to process the encryption route.
    // frist do one to localhost:1055 to make sure that I can access all the variable bames... ONCE TESTED ABOVE AND WE CAN SEE THAT THE FILE HAS GONE...
  
    setTimeout(() => {  
              console.log("A Simple Pause! 1");

            // encryptPDF_FTP_Backvault
            data.password = this.returned_file_password;
            this.encryptPDF_FTP_Backvault(data); // Runs the API Encryption on the file uploaded // to route encrypt/PDF/so/ftp/:uid


      


            setTimeout(() => {  
              // get the file automatically
                  // Once Finished Need to pull back and then encryot data... two functions
             this.getdDocumentUploadedViaFTP_AdobeAPI_Backvault(data, filename, subject_number, data.file_job_id); // new adobe api send via fftp to resources folder.
             this.encryptSystemFileJustData(data);
             }, 12000);


             setTimeout(() => {  
              // remove the files from AdobeAPI Via FTP delelte. (resourses and output/ProtectPDF directories)
              this.deleteUploadedDocumentCreatedViaFTP_AdobeAPI_Backvault(data, data.full_file_name, data.file_subject_number, data.file_job_id)
             this.toastr.info("cleaning up... thanks. Done.")
     
             }, 30000);


     }, 6000);

}



onClickMergeDocumentEncrypt_adobeAPI_FTP_SO(filename, subject_number, data, file_url) {
  // First sentIT to tsaVM / created Files - works.
  if (confirm('Are you sure you want to encrypt and lock file with a password? ')) {

  // Comment out and put file manuall for local testing. --
 // first delete the files - on the API server // DELETEING BEFORE CREATED HEAPS OF ISSUES>.....

  this.encryptSystemFileGetPassword(data); // load the passwords.

  // works commented out for testing as file lready uploaded.
  this.sendDocumentUploadedViaFTP_AdobeAPI_SO(data, filename, subject_number, data.file_job_id); // new adobe api send via fftp to resources folder.
  // This now also creates resources/originals to keep backups online.

    this.templateDocxName = data.full_file_name;
    this.file_subject_number = subject_number;

    // Now create a new Demo services Route to get acess to adobeapi.tsa_backvault.com.au -- to process the encryption route.
    // frist do one to localhost:1055 to make sure that I can access all the variable bames... ONCE TESTED ABOVE AND WE CAN SEE THAT THE FILE HAS GONE...
  
    setTimeout(() => {  
              console.log("A Simple Pause! 1");

            // encryptPDF_FTP_Backvault
            data.password = this.returned_file_password;
            this.encryptPDF_FTP_AdobeAPI(data); // Runs the API Encryption on the file uploaded // to route encrypt/PDF/so/ftp/:uid


      

// larger fils need a larger time period or I need to build a try three times if first fails on ftp pull.
            setTimeout(() => {  
              // get the file automatically
                  // Once Finished Need to pull back and then encryot data... two functions
             this.getdDocumentUploadedViaFTP_AdobeAPI_SO(data, filename, subject_number, data.file_job_id); // new adobe api send via fftp to resources folder.
       this.encryptSystemFileJustData(data);
             }, 12000);

             setTimeout(() => {  
              // remove the files from AdobeAPI Via FTP delelte. (resourses and output/ProtectPDF directories)
           this.deleteUploadedDocumentCreatedViaFTP_AdobeAPI_SO(data, data.full_file_name, data.file_subject_number, data.file_job_id)
             this.toastr.info("cleaning up... thanks. Done.")
     
             }, 30000);


     }, 6000);
    }
}


httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  onClickMergeDocumentEncrypt_adobeAPI_FTP_SO_Observables(filename, subject_number, data, file_url){
    // Furst get the data Directly....
    // 1 :: Get the Passwords
    const $returned_file_password = this.http.post<[]>( environment.php_apiURL_SSL + '/docx_encrypt_return_password.php?mergeJobData=' + filename, data, this.httpOptions);
    // 2:: Remove From the Server -- Checker...  Or just Run the function 
    const $adobeAPI_upload_delete = this.http.post<[]>( environment.php_apiURL_SSL + '/tsaVM_ftp_out_document_uploaded_delete_AdobeAPI_SO.php?filename=' + filename + '&subject_number=' + subject_number + '&job_id=' + data.file_job_id, data, this.httpOptions);
    
    // -- need to move this after the delete process.
    // 3 :: Send Documents To the adobeapi.sharmans.net.au server
    const $adobeAPI_upload = this.http.post<[]>( environment.php_apiURL_SSL + '/adobeAPI_ftp_out_document_uploaded_SO.php?filename=' + filename + '&subject_number=' + subject_number+ '&job_id=' + data.file_job_id, data, this.httpOptions);
    // const $adobeAPI_upload = this.http.post<[]>( environment.php_apiURL_SSL + '/adobeAPI_ftp_out_document_uploaded.php?filename=' + filename + '&subject_number=' + data.subject_number+ '&job_id=' + data.file_job_id, data, this.httpOptions);
    
    
    const $adobeAPI_download = this.http.post<[]>( environment.php_apiURL_SSL + '/adobeAPI_ftp_in_document_uploaded_SO.php?filename=' + filename + '&subject_number=' + subject_number+ '&job_id=' + data.file_job_id, data, this.httpOptions);
    
    
    
    
    
    
    // :: Need post not get function.
      // Need to fix the delete file function to return JSON... (positive even if file does not exists, just so that the function can still run.)
    
    
    // Now we jon the results.
    forkJoin([$returned_file_password, $adobeAPI_upload_delete]) // delete the files.
    .pipe(
    this.toastr.observe({
      loading: 'Gathering ... All Informaton',
      success: '🚀',
      error: '...😡  FAILED...' + data.flle_job_number
    })
    )
    .subscribe(([returned_file_password, adobeAPI_upload_delete]) => {
    // All data available
    // console.log(countries);
    // console.log(cities);
    this.resultMessage = `Fetched ${returned_file_password}  and Deleted ${adobeAPI_upload_delete} from the server.`;
    console.log(this,this.resultMessage);
    
    this.templateDocxName = data.full_file_name;
    this.file_subject_number = subject_number;
    
    
    // START CHILD A -- Remove 
        // We can Start to Process The document Now.
        // child need to go and create the file... and once created.
    
    
            // Now we jon the results. -- Upload the Files
            forkJoin([$adobeAPI_upload])
            .pipe(
            this.toastr.observe({
            loading: 'AdobeAPI :: Uploading Files to Process',
            success: '🚀',
            error: '...😡  FAILED...' + data.flle_job_number
            })
            )
            .subscribe(([adobeAPI_upload]) => {
    
              this.adobeAPI_upload = adobeAPI_upload;
              // this.returned_AdobeAPI_go_encrypt = returned_AdobeAPI_go_encrypt;
              this.toastr.success('File Upload Success')
           
           
              setTimeout(() => {  
                console.log("Pause to create file");
    
    
                // :: need to move this to after I move the files.
              // 4 :: Encrypt API
              // encryptPDF_FTP_Backvault
              this.returned_file_password = JSON.stringify(returned_file_password);
              data.password = this.returned_file_password; // only item in the reutnrded object.(no this... as now gets directy from the observable above.)
              const $returned_AdobeAPI_go_encrypt = this.http.post<[]>( this._demoService.$api_get_adobeAPI + '/encrypt/PDF/so/ftp/' + data.full_file_name, data, this.httpOptions);
              const $AdobeAPI_succes_close_data = this.http.post<[]>( environment.php_apiURL_SSL + '/docx_encrypt_just_data.php?mergeJobData=', data, this.httpOptions);
    
    
              // Start Child B
              // Encrypt the file in the server.
                        forkJoin([$returned_AdobeAPI_go_encrypt]) // encrypt the files
                        .pipe(
                        this.toastr.observe({
                        loading: 'AdobeAPI Encryption Processing',
                        success: '🚀',
                        error: '...😡  FAILED...' + data.flle_job_number
                        })
                        )
    
                        
                        .subscribe(([returned_AdobeAPI_go_encrypt]) => {
    
                          this.returned_AdobeAPI_go_encrypt = returned_AdobeAPI_go_encrypt;
                    
                          this.toastr.success('File Encrytion Success')
    
                            
                          
                          
                          setTimeout(() => {  
                            console.log("Pause waiting on file... ");
                
                          // If child C
                                  // Pull The Files Back. 
                                  // if required to remove the files after we have finished 
                                  forkJoin([$adobeAPI_download, $AdobeAPI_succes_close_data])
                                          .pipe(
                                          this.toastr.observe({
                                          loading: 'AdobeAPI Downloading Encrypted Files',
                                          success: '🚀',
                                          error: '...😡  FAILED...' + data.flle_job_number
                                          })
                                          )
                                          .subscribe(([adobeAPI_download, AdobeAPI_succes_close_data]) => {
                                  
                                            this.adobeAPI_download = adobeAPI_download;
                                            this.AdobeAPI_succes_close_data = AdobeAPI_succes_close_data;
                                            this.refreshGrid();
                                            this.toastr.success('Download Success')
                                  
                                          }); // end child C
    
    
                              
    
                           }, 30000); // end second timeout. -- files bigger than 10 gig....
    
                        });   // End Child B
    
                        
    
                     }, 10000); // end first time out.
    
    
    
    
            }); // END CHILD A
        // 
    
    
    
    
    
    
    // // START CHILD 
    //     // We can Start to Process The document Now.
    //     // child need to go and create the file... and once created.
    //         const $returned_AdobeAPI_go_encrypt = this.http.post<[]>( this._demoService.$api_get_adobeAPI + '/encrypt/PDF/so/ftp/' + data.full_file_name, data, this.httpOptions);
    
    //         // Now we jon the results.
    //         forkJoin([$returned_AdobeAPI_go_encrypt])
    //         .pipe(
    //         this.toastr.observe({
    //         loading: 'AdobeAPI Encryption Processing',
    //         success: '🚀',
    //         error: '...😡  FAILED...' + data.flle_job_number
    //         })
    //         )
    //         .subscribe(([returned_AdobeAPI_go_encrypt]) => {
    
    //           this.returned_AdobeAPI_go_encrypt = returned_AdobeAPI_go_encrypt;
    //           this.toastr.success('File Encrytion Success')
    
    //         });
    //     // sibscruibe to the response and do the datas, and cleaning
    
    // // END CHILD
    
    }); // end subjscription master
    } // end function




// How to covert pdf file to base64
// ::@https://stackoverflow.com/questions/36280818/how-to-convert-file-to-base64-in-javascript

  // Function runs
  async onClickMergeDocumentEncrypt_FTP(filename, subject_number, data, file_url) {
    if (confirm('Are you sure you want to encrypt and lock file with a password? ')) {
   
    // : 'https://tsa.backvault.com.au/APP_PHP/uploads/assets/jobs',
  
    
    // Location if uploaded file.
  // this.convertToBase64_viaURL( this.gfunc.baseUploadURL_JobAssets + '/' + data.file_job_id + '/' + data.file_name);
  
  // First sentIT to tsaVM / created Files - works.
  // Comment out and put file manuall for local testing. --
  this.encryptSystemFileGetPassword(data); // load the passwords.
  this.sendDocumentUploadedViaFTP(data, filename, subject_number, data.file_job_id);
  
    this.templateDocxName = data.full_file_name;
    this.file_subject_number = subject_number;
  
    // once document there run the route to manuputalre the fule
  
    // pull it back//
    // set permissions in data
  
  
  
  
    // I NEED THE PASSWORD!!!!!
  
  
               // Run the Single push invcoice Route and 
               setTimeout(() => {  
                console.log("A Simple Pause! 1");
    
   
  
                const postDocument: MergedDocument = {
                  document: this.set_PDF_blob,
                  DocumentName: data.full_file_name,
                  // password: 'textcontrol3', // also remember if type of user... so set in a function first.
                  password: this.returned_file_password, // also remember if type of user... so set in a function first.
                  model: ''
                };
  
       // Test if this runs to function and then  
    //   loadDocument(result.document);
    // this.sendWordTemplateViaFTP(data, filename); // moves file over ready for merge in PHP
    //  this.toastr.success('Succesfully Encrypted The new created document!', {icon: '👏🌞',})
  
    console.log("File in Base64: in time ", this.set_PDF_blob);
  
    // post the document to endpoint 'MergeDocument' // Saves the file as the same name. // see if works. may not was the file may be open in the stream -- DONE WORKS 
              this.http.post<MergedDocument>(this._baseUrl + 'textcontrol/mergedocumentencrypt_LocalFile' + '?documentName='+ data.full_file_name, postDocument).subscribe(result => {
                // this.http.post<MergedDocument>('http://20.70.181.64:80/' + 'textcontrol/mergedocument' + '?DocumentName=' + this.templateDocxName, postDocument).subscribe(result => {
              
  
                // this.http.post<MergedDocument>(this._baseUrl + 'textcontrol/mergedocument', postDocument).subscribe(result => {
                // load the results into TXTextControl
                
  
                // Lets conver the Blob and save as PDF through php send and acreate API and function to do this.
                // LETS PULL THE FILE BACK!
  
                // Need to test this function live Put and get...
                // this.toastr.success('Enctypted PDF File Successfully')
                this.toastr.info('Enctypting file...')
              
  
  
  
                setTimeout(() => {  
                console.log("A Simple Pause! 2 inside");
  
                  this.getUploadedDocumentCreatedViaFTP(data, data.full_file_name, data.file_subject_number, data.file_job_id);
                  // Now lock down the file data
                  this.encryptSystemFileJustData(data);
                  // this.sendUploadedDocumentCreatedViaFTP_Delete(data, data.full_file_name, data.file_subject_number, data.file_job_id)
                   // get the file automatically
                //   this.getUploadedDocumentCreatedViaFTP(data, data.full_file_name, data.file_subject_number, data.file_job_id);
                  // Swtich this back on when I correct the process fully.
               //   this.encryptSystemFileJustData(data);
                  }, 1000);
  
  
  
              }, error => console.error(error));
  
  
  
  
              
  
            }, 6000);
  
  
  
  
  
          }
  
  }


// Idealy resposnse in php file needs to be fixed to return json .-- but allworks.
public sendDocumentUploadedViaFTP(model, filename, subject_number, job_id){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.sendDocumentUploadedViaFTP(model, filename, subject_number, job_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent to tsaVM via ftp.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
    //  this.toastr.error('Error sending to tsaVM via ftp');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
  // this.toastr.success('Sent to tsaVM via ftp.');
}



public sendDocumentUploadedViaFTP_AdobeAPI_Backvault(model, filename, subject_number, job_id){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.sendDocumentUploadedViaFTP_AdobeAPI_Backvault(model, filename, subject_number, job_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent to tsaVM via ftp.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
    //  this.toastr.error('Error sending to tsaVM via ftp');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
  // this.toastr.success('Sent to tsaVM via ftp.');
}


public sendDocumentUploadedViaFTP_AdobeAPI_SO(model, filename, subject_number, job_id){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.sendDocumentUploadedViaFTP_AdobeAPI_SO(model, filename, subject_number, job_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent to tsaVM via ftp.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
    //  this.toastr.error('Error sending to tsaVM via ftp');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
  // this.toastr.success('Sent to tsaVM via ftp.');
}





public getdDocumentUploadedViaFTP_AdobeAPI_Backvault(model, filename, subject_number, job_id){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.getDocumentUploadedViaFTP_AdobeAPI_Backvault(model, filename, subject_number, job_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent to tsaVM via ftp.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
    //  this.toastr.error('Error sending to tsaVM via ftp');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
  // this.toastr.success('Sent to tsaVM via ftp.');
}



public getdDocumentUploadedViaFTP_AdobeAPI_SO(model, filename, subject_number, job_id){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.getDocumentUploadedViaFTP_AdobeAPI_SO(model, filename, subject_number, job_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent to tsaVM via ftp.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
    //  this.toastr.error('Error sending to tsaVM via ftp');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
  // this.toastr.success('Sent to tsaVM via ftp.');
}



public getDocumentCreatedViaFTP(model, filename, subject_number){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.getDocumentCreatedViaFTP(model, filename, subject_number).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Sent to tsaVM via ftp.');
      const res = data;

    },
    (error) => {
     this.toastr.error('Error sending to tsaVM via ftp');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
  this.toastr.success('File Back Home APP_PHP via ftp from tsaVM.');
}

// New created to get the new encrypted document from the Azure Server
public getUploadedDocumentCreatedViaFTP(model, filename, subject_number, job_id){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.getUploadedDocumentCreatedViaFTP(model, filename, subject_number, job_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent to tsaVM via ftp.');
      const res = data;

    },
    (error) => {
    //  this.toastr.error('Error sending to tsaVM via ftp');
    //  return console.log(error);
    }
  );
  // once moved it is the ready for processing.
  this.toastr.success('File Back Home APP_PHP via ftp from tsaVM.');
}





public sendWordTemplateViaFTP(model, filename){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.sendWordTemplateViaFTP(model, filename).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Sent Fle Via FTP.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
    // once moved it is the ready for processing.
    this.toastr.success('File get via ftp from tsaVM -> APP_PHP.');
}



public sendUploadedDocumentCreatedViaFTP_Delete(model: any, filename:any, subject_number: any, job_id: any){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.sendUploadedDocumentCreatedViaFTP_Delete(model, filename, subject_number, job_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Deleted Fle Via FTP.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
    // once moved it is the ready for processing.
    this.toastr.success('File Deleted via ftp from tsaVM -> APP_PHP.');
}




public deleteUploadedDocumentCreatedViaFTP_AdobeAPI_Backvault(model: any, filename:any, subject_number: any, job_id: any){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.deleteUploadedDocumentCreatedViaFTP_AdobeAPI_Backvault(model, filename, subject_number, job_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Deleted Fle Via FTP - AdobeAPI Backvault.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
    // once moved it is the ready for processing.
    this.toastr.success('File Deleted via ftp from tsaVM -> APP_PHP.');
}



public deleteUploadedDocumentCreatedViaFTP_AdobeAPI_SO(model: any, filename:any, subject_number: any, job_id: any){
  // send filename to get from tsaVM and place in PHP_APP/WordTemplates
  this._mysqlService.deleteUploadedDocumentCreatedViaFTP_AdobeAPI_SO(model, filename, subject_number, job_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Deleted Fle Via FTP - AdobeAPI SO.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res.text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
     return console.log(error);
    }
  );
  // once moved it is the ready for processing.
    // once moved it is the ready for processing.
    this.toastr.success('File Deleted via ftp from AdobeAPI SO.');
}




// https://upmostly.com/angular/converting-files-to-base64-in-angular
onFileSelected(event) {
  this.convertFile(event.target.files[0]).subscribe(base64 => {
    this.base64Output = base64;
  });
}

convertFile(file : File) : Observable<string> {
  const result = new ReplaySubject<string>(1);
  const reader = new FileReader();
  reader.readAsBinaryString(file);
  reader.onload = (event) => result.next(btoa(event.target.result.toString()));
  return result;
}


convertToBase64_viaURL(url: string) {

  // const httpOptions = {
  //   headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       'Access-Control-Allow-Origin': '*',
  //       'Access-Control-Allow-Credentials': 'true',
  //       'Access-Control-Allow-Headers': 'Content-Type',
  //       'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
  //       'key': 'x-api-key',
  //       'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

  //   })
  // };







  this.http.get(url,  { responseType: "blob" }).subscribe(blob => {
    const reader = new FileReader();
    const binaryString = reader.readAsDataURL(blob);
    reader.onload = (event: any) => {
      //Here you can do whatever you want with the base64 String
      console.log("File in Base64: ", event.target.result);

// need to remove -- data:application/pdf;base64, up to the first comma -- to make a valid document.
var str = event.target.result;
str = str.substring(str.indexOf(",") + 1);

      // this.set_PDF_blob = event.target.result;
      this.set_PDF_blob = str;
    };

    reader.onerror = (event: any) => {
      console.log("File could not be read: " + event.target.error.code);
    };
  });
}

return_convertToBase64_viaURL(url: string) {

  // const httpOptions = {
  //   headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       'Access-Control-Allow-Origin': '*',
  //       'Access-Control-Allow-Credentials': 'true',
  //       'Access-Control-Allow-Headers': 'Content-Type',
  //       'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
  //       'key': 'x-api-key',
  //       'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

  //   })
  // };







  this.http.get(url,  { responseType: "blob" }).subscribe(blob => {
    const reader = new FileReader();
    const binaryString = reader.readAsDataURL(blob);
    reader.onload = (event: any) => {
      //Here you can do whatever you want with the base64 String
      console.log("File in Base64: ", event.target.result);
     return this.set_PDF_blob = event.target.result;
    };

    reader.onerror = (event: any) => {
      console.log("File could not be read: " + event.target.error.code);
    };
  });
}


http_GET(actionUrl: any): Observable<any> {

 let actionURL2 = this.gfunc.baseUploadURL_JobAssets + '/' + actionUrl.file_job_id + '/' + actionUrl.file_name

console.log('ActionURL2: ' + actionURL2 )

  const httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          // 'key': 'x-api-key',
          // 'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.get<any>(actionURL2, httpOptions).pipe(
      (response => {      
          console.log(response);  
          return response;
      }));
}








}
